export const contactsHeaderTitles = {
  title: 'Contacts',
  orderBtn: 'Order',
};
